<div class="container">
	<div class="row">
		<div class="col-lg-12">
			<div class="item-panel">
				<div class="heading">Manage all assets</div>
				<div class="content">
					<div class="row">
						<div class="col-lg-4">
							<div *ngIf="treenodes" class="tree-box">
								<tree-root #treeView class="asset-tree" [nodes]="treenodes" [options]="treeoptions" (activate)="ActivateNode($event.node)"></tree-root>
							</div>
							<div *ngIf="!treenodes">Loading...</div>
						</div>
						<div class="col-lg-8">
							<div *ngIf="!selectedItem && allAssets">
								<h3 class="node-header">Fleetwide operations</h3>
								<ul ngbNav #navAll="ngbNav" class="nav-tabs">
									<li ngbNavItem>
										<a ngbNavLink>Asset Logins</a>
										<ng-template ngbNavContent>
											<app-manage-all-asset-logins [assets]="allAssets"></app-manage-all-asset-logins>
										</ng-template>
									</li>
									<li ngbNavItem>
										<a ngbNavLink>User Logins</a>
										<ng-template ngbNavContent>
											<app-manage-all-user-logins></app-manage-all-user-logins>
										</ng-template>
									</li>
									<li ngbNavItem>
										<a ngbNavLink>Firmware</a>
										<ng-template ngbNavContent>
											<app-manage-all-firmware></app-manage-all-firmware>
										</ng-template>
									</li>
								</ul>
								<div [ngbNavOutlet]="navAll">Nav goes here</div>
							</div>
							<div *ngIf="selectedItem">
								<h3 class="node-header">{{selectedItem.name}}</h3>
								<!-- Org node info -->
								<div *ngIf="selectedItem.id.startsWith('org')">
									<hr>
									<app-expander caption="Add new fleet">
										<div class="form-group row">
											<label class="col-md-4">Fleet name</label>
											<div class="col-md-8">
												<input [(ngModel)]="newFleetName" type="text" class="form-control">
											</div>
										</div>
										<div class="form-group row">
											<div class="col-md-8 offset-md-4">
												<app-action-button [action]="AddFleet" [context]="this" processing="Adding..." complete="Fleet added">Add Fleet</app-action-button>
											</div>
										</div>
									</app-expander>
								</div>
								<!-- Fleet node info -->
								<div *ngIf="selectedItem.id.startsWith('flt')">
									<div class="row">
										<div class="col-12 mb-3">
											<a [href]="'/dash/fleet/' + selectedItem.fleet_id">Open in Foresight <i class="icon-link-ext"></i></a>
										</div>
									</div>
									<div class="form-group row">
										<label class="col-md-4">Time display offset (hrs):</label>
										<div class="col-md-8">
											<input type="number" [(ngModel)]="selectedItem.time_offset_hours">
										</div>
									</div>
									<div class="form-group row">
										<label class="col-md-4">Hidden from dashboard:</label>
										<div class="col-md-8">
											<input [(ngModel)]="selectedItem.hidden" type="checkbox" class="form-check-input">
										</div>
									</div>
									<div class="form-group row">
										<div class="col-md-12">
											<app-action-button [action]="UpdateFleet" [context]="this" processing="Updating..." complete="Fleet updated" btnClass="btn-primary">Update Fleet
											</app-action-button>
										</div>
									</div>
									<hr>
									<app-expander caption="Add new asset/OBCU">
										<div class="form-group row">
											<label class="col-md-4">Configuration</label>
											<div class="col-md-8">
												<select [(ngModel)]="newAsset.asset_type_id" class="form-control">
													<option *ngFor="let config of orgConfigs" [ngValue]="config.asset_type_id">{{config.asset_type_name}}
													</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label class="col-md-4">Asset name</label>
											<div class="col-md-8">
												<input [(ngModel)]="newAsset.asset_name" type="text" class="form-control">
											</div>
										</div>
										<div class="form-group row">
											<label class="col-md-4">OBCU serial number</label>
											<div class="col-md-6">
												<input [(ngModel)]="newAsset.obcu_serial_number" type="text" class="form-control">
											</div>
											<div *ngIf="!brand.localCloud" class="col-md-2">
												<app-action-button [action]="FreshenSerial" [context]="this" processing="..." btnClass="btn-primary" title="Fetch next serial">◀</app-action-button>
											</div>
										</div>
										<div class="form-group row">
											<div class="col-md-8 offset-md-4">
												<app-action-button [action]="AddAsset" [context]="this" processing="Adding..." complete="Asset added">Add Asset</app-action-button>
											</div>
										</div>
										<div *ngIf="newAssetAuth">
											<p class="message-good">The asset has been created, with the auth key below. Copy this key and
												save
												it to the OBCU config. You will not
												be able to come back and look it up again.</p>
											<div class="form-group row">
												<label class="col-md-4">Asset auth key</label>
												<div class="col-md-8">{{newAssetAuth}}</div>
											</div>
										</div>
									</app-expander>
									<app-expander *ngIf="selectedItem.fleet_id" caption="Delete this fleet">
										<p>Note that any assets currently assigned to this fleet will be moved into the "No fleet assigned"
											group</p>
										<div class="form-group row">
											<div class="col-md-8 offset-md-4">
												<app-action-button [action]="DeleteFleet" [context]="this" processing="Deleting..." complete="Fleet deleted"
													confirm="Are you sure? Assets will be moved to 'No fleet assigned'" btnClass="btn-danger">Delete Fleet</app-action-button>
											</div>
										</div>
									</app-expander>
								</div>
								<!-- Asset node info -->
								<div *ngIf="selectedAsset">
									<div class="row">
										<div class="col-12 mb-3">
											<a [href]="'/dash/fleet/' + selectedAsset.fleet_id + '/asset/' + selectedAsset.asset_id">Open in Foresight <i class="icon-link-ext"></i></a>
										</div>
									</div>
									<ul ngbNav #navAsset="ngbNav" class="nav-tabs">
										<li ngbNavItem>
											<a ngbNavLink>General</a>
											<ng-template ngbNavContent>
												<app-manage-general [asset]="selectedAsset" (AssetUpdated)="AssetUpdated()"></app-manage-general>
											</ng-template>
										</li>
										<li ngbNavItem>
											<a ngbNavLink>Notes</a>
											<ng-template ngbNavContent>
												<app-manage-notes [asset]="selectedAsset"></app-manage-notes>
											</ng-template>
										</li>
										<li ngbNavItem>
											<a ngbNavLink>Files</a>
											<ng-template ngbNavContent>
												<app-manage-files [asset]="selectedAsset"></app-manage-files>
											</ng-template>
										</li>
										<li ngbNavItem>
											<a ngbNavLink>Data</a>
											<ng-template ngbNavContent>
												<app-manage-data [asset]="selectedAsset"></app-manage-data>
											</ng-template>
										</li>
										<li ngbNavItem>
											<a ngbNavLink>Partner organizations</a>
											<ng-template ngbNavContent>
												<app-manage-partner [asset]="selectedAsset"></app-manage-partner>
											</ng-template>
										</li>
										<li ngbNavItem>
											<a ngbNavLink>Destructive ops</a>
											<ng-template ngbNavContent>
												<app-manage-destructive [asset]="selectedAsset"></app-manage-destructive>
											</ng-template>
										</li>
									</ul>
									<div [ngbNavOutlet]="navAsset">Nav goes here</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>